<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <header>
    <h1>Add Notification</h1>
    <button
      mat-dialog-close
      mat-icon-button
      matTooltip="Close."
      class="closeButton"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section mat-dialog-content class="body">
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input formControlName="title" matInput required maxlength="200" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Text</mat-label>
      <textarea
        matInput
        formControlName="text"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        required
        maxlength="1000"
      ></textarea>
      <mat-hint class="characterHint">
        {{this.form.get('text').getRawValue()?.length ?
        this.form.get('text').getRawValue()?.length : 0}}/1000</mat-hint
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>Image Url</mat-label>
      <input formControlName="image" matInput />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Link Url</mat-label>
      <input formControlName="url" matInput />
    </mat-form-field>
  </section>
  <section align="end" mat-dialog-actions class="actions">
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="loading"
      mat-button
      matTooltip="Save product info."
      type="submit"
    >
      <mat-icon>send</mat-icon>
      Send
    </button>
  </section>
</form>
